import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  filterDistricts(event) {
    const county = event.target.value
    const clearButton = document.getElementById('clear-county')
    const frame = document.getElementById('district-dropdown')

    if (county) {
      clearButton.style.display = 'block'
    } else {
      clearButton.style.display = 'none'
    }

    // Load the district dropdown via Turbo Frame src attribute
    frame.src = `/admin_school_districts_for_county?county=${encodeURIComponent(county)}`
  }

  clearCounty(event) {
    event.preventDefault()
    const countySelect = document.getElementById('q_county_eq')
    const frame = document.getElementById('district-dropdown')

    countySelect.value = ''
    document.getElementById('clear-county').style.display = 'none'

    // Reload districts with no county filter
    frame.src = '/admin_school_districts_for_county?county='
  }
}
